import { j as json, e as error } from "../../../../chunks/index2.js";
import { g as get, U as UserCollection } from "../../../../chunks/firebase.js";
const GET = async ({ url }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  if (email) {
    const user = await get(UserCollection(), email);
    if (user.data) {
      await UserCollection().doc(user.data.id).set(user.data);
      await user.ref.delete();
      return json(user.data);
    }
    return json({ error: "User not found" }, { status: 404 });
  }
  return json({ error: "No query provided" }, { status: 400 });
};
const POST = async ({ request }) => {
  const body = await request.json();
  const user = await get(UserCollection(), body.id);
  if (user.data) {
    if (user.data.license !== body.license) {
      return error(403, { message: "Cannot change license" });
    }
  } else {
    if (body.license !== "free") {
      return error(403, { message: "Invalid license" });
    }
  }
  await user.ref.set(body, { merge: true });
  return json(body);
};
export {
  GET,
  POST
};
